class AppointmentChoiceDateTimeForm {
    constructor(element) {
        this.element = element
        this.TimeListHandler = new TimeListHandler(this.timeList)
        this.initListeners()
    }

    initListeners() {
        this.initChoiceTimeListener()
    }

    initChoiceTimeListener() {
        $(this.timeList).on('time:choice', this.emitClickOnSubmitButton.bind(this))
    }

    emitClickOnSubmitButton() {
        this.submitButton.click()
    }

    get submitButton() {
        return $(this.element).find('.js-appointment-choice-date-time-button')
    }

    get timeList() {
        return $(this.element).find('.js-appointment-choice-date-time-list')
    }
}

$('.js-appointment-choice-date-time-form').each((i, element) => {
    new AppointmentChoiceDateTimeForm(element)
})
